import React, { useState } from 'react';
import propTypes from 'prop-types';
import { URL_SCALE_LARGE } from '../../constance/urls';
import { useTranslation } from 'react-i18next';
import { useDebounce } from "use-debounce";
import useSearchItem from '../../hooks/useSeatchItem';
import useItemDetail from '../../hooks/useItemDetail';
import useDropdownItem from '../../hooks/useDropdownItem';
import * as _ from 'lodash';
import { Button, Modal, Form, Input, Select, AutoComplete, Space, Typography } from "antd";

export default function CreateTruckTransactionModal(props) {

  const {
    open,
    onClose,
    onFinish,
  } = props;

  const { Text } = Typography;
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const truckTypes = useDropdownItem({ url: URL_SCALE_LARGE.TRUCK_TYPE, text: "name" });
  const truckCompanies = useSearchItem({ url: URL_SCALE_LARGE.TRUCK_COMPANY, description_render: 'name', title_render: 'code' });

  const truck_type = Form.useWatch('truck_type', form);
  const truck_company_name = Form.useWatch('truck_company_name', form)
  const [debouncedText] = useDebounce(truck_company_name, 500);

  React.useEffect(() => {
    if (open) {
      form.resetFields()
    }
  }, [open])

  React.useEffect(() => {
    if (debouncedText) {
      console.log('de', debouncedText)
      truckCompanies.fetchData({ search: debouncedText })
    }
  }, [debouncedText])

  return (
    <Modal
      title={`${t('create')} ${t('trucks.license_plate')}`}
      open={open}
      onCancel={onClose}
      footer={[
        <Button type="primary" htmlType="submit"
          onClick={async () => {
            const temp = await form.validateFields();
            onFinish(temp)
            onClose()
          }}>Submit</Button>
      ]}
    >

      <Form layout='vertical' form={form}>
        <Form.Item name={"truck_company"} hidden />
        <Form.Item
          label={t('truck_transactions.company')}
          name={"truck_company_name"}
          rules={[{ required: true, message: t('error_messages.validation.required') }]}>
          <AutoComplete
            options={truckCompanies.response.map((company) => ({
              value: company.name,
              label: (
                <Space direction="vertical" size={1}>
                  <Text strong>{company.code}</Text>
                  <Text type="secondary" >{company.name}</Text>
                </Space>
              ),
              result: company,
            }))
            }
            onSelect={(__, data) => {
              form.setFieldsValue({ truck_company: data.result.code ? data.result.code : "" })
            }}
            notFoundContent={truck_company_name ? t('no_data') : ""}
          >
            <Input.Search
              placeholder={`${t('search')} ${t('searchs.fields.code')} ${t('or')} ${t('searchs.fields.name')}...`}
              loading={truckCompanies.isLoading}
            />
          </AutoComplete>
        </Form.Item>
        <Form.Item name={"truck_type_name"} hidden />
        <Form.Item
          label={t('wood_imports.truck_license_plate')}
          name='license_plate'
          rules={[{ required: true, message: t('error_messages.validation.required') }]}>
          <Input />
        </Form.Item>
        <Form.Item label={t('trucks.type')} name={"truck_type"} rules={[{ required: true, message: t('error_messages.validation.required') }]}>
          <Select options={truckTypes.response} allowClear />
        </Form.Item>
      </Form>

    </Modal >
  )
}

CreateTruckTransactionModal.defaultProps = {
  open: false,
  onClose: () => null,
  onFinish: (_) => null,
}

CreateTruckTransactionModal.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
  onFinish: propTypes.func,
}